import React, { useEffect, useState } from 'react';
import Drawer from 'react-modern-drawer';
import directoryServices from '../directoryServices';
import { SelectContact } from '../../../components/Contacts/selectContact';
import MasterReleaseForm from '../../../components/Common/MasterForm';
import Pagination from '../../../components/Header/Pagination';
import { CommonUtilities } from '../../../commonUtils';
import { ContactFormSearch } from '../../Contacts/contactFormSearch';

export default function ReleaseSlider(param: any) {

    let [slider, setslider] = useState(false)
    let [sliderIndex, setsliderIndex] = useState(0)
    let [EditValue, setEditValue] = useState<any>([]);
    let [saveStatus, setSaveStatus] = useState(false);
    let [listImprint, setlistImprint] = useState<any>([]);
    let [imageUpload, setImageUpload] = useState<any>([]);
    let [ClassificationSearch, setClassificationSearch] = useState("");
    let [listClassification, setlistClassification] = useState<any>([]);
    let [ClassificationtotalRow, setClassificationtotalRow] = useState(1);
    let [SubClassificationSearch, setSubClassificationSearch] = useState("");
    let [listSubClassification, setlistSubClassification] = useState<any>([]);
    let [SubClassificationtotalRow, setSubClassificationtotalRow] = useState(1);
    let [associatedclassification, setassociatedclassification] = useState<any>([]);
    let [associatedSubclassification, setassociatedSubclassification] = useState<any>([]);

    const closePage = () => {
        param.onAddClose(EditValue);        
        EditValue = [];
        setEditValue(EditValue);
    } 

    useEffect(() => {
        directoryServices.imprintListing().then((res) => {
            setlistImprint(res)
        })

        console.log(param.editData)
        if (param.editData) {

            console.log(EditValue)

            if (param.editData && param.editData.assetCode) {
                directoryServices.metadataReleaseListing({ releaseCode: param.editData.assetCode }).then((values) => {
                    console.log(values)
                    setEditValue({ ...values[0], artistName: param.editData.assetContactName, artist: param.editData.assetContactName, image: param.editData.assetImageTH });


                    setSaveStatus(true)
                    directoryServices.musicDirectoryCategoryListing({ code: param.editData.assetCode, CategoryType: "Releases" }).then((res) => {
                        setassociatedclassification(res)
                    })

                    SubclassFicationPayload.referenceCode = param.editData.assetCode;

                    directoryServices.tagListing(SubclassFicationPayload).then((res) => {
                        setassociatedSubclassification(res)
                    })
                })
            }

        }
    }, [param.open]);


    let SubclassFicationPayload = {  area: "Releases",  referenceCode: "", text: "", pageNumber: 1, pagesize: 10  }
    let classFicationPayload = { formArea: "Releases",  pageNumber: 1,  pagesize: 10, useFreeText: "" }

    const ClassificationListing = () => {
        if (ClassificationSearch.length > 1) {
            classFicationPayload.useFreeText = ClassificationSearch;
        }
        directoryServices.zFreeTextListing(classFicationPayload).then((res) => {
            setlistClassification(res)
            setClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })
    }

    const ClassificationSave = (e: any) => {

        if (e !== false) {

            directoryServices.musicDirectoryCategorySave({ Code: EditValue.barcodeNum, categoryName: e, categoryType: "Releases" });
            loadAssociated();
        } else {
            directoryServices.zFreeTextsave({ formArea: "Releases", useFreeText: ClassificationSearch });
            directoryServices.musicDirectoryCategorySave({ Code: " ", categoryName: ClassificationSearch, categoryType: "Releases" });
            loadAssociated();
        }

    }

    const SubClassificationListing = () => {

        if (SubClassificationSearch.length > 1) {
            SubclassFicationPayload.text = SubClassificationSearch;
        }
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setlistSubClassification(res)
            setSubClassificationtotalRow(res[0] ? res[0].totalRows : 0)
        })

    }

    const SubClassificationSave = (e: any) => {

        console.log(e)
        if (e !== false) {
            //directoryServices.musicDirectoryCategorySave({ Code: EditValue.barcodeNum, categoryName: e, categoryType: "Releases" });
            directoryServices.tagSave({ text: e, referenceCode: param.editData.assetCode, code: e, area: "Releases",isActive: 1, isCustom: 1 });
            loadAssociated();
        } else {
            //directoryServices.tagSave({ area: "Releases", code: e, id: 0, isActive: 1, isCustom: 1, referenceCode: " ", text: e });
            directoryServices.tagSave({ area: "Releases", code: SubClassificationSearch, id: 0, isActive: 1, isCustom: 1, referenceCode:param.editData.assetCode, text: SubClassificationSearch });                        
            loadAssociated();
        }

    }

    const deleteSubTaging = (e: any) => {
        directoryServices.tagdelete(e).then((res) => {
            SubclassFicationPayload.referenceCode = " ";
            directoryServices.tagListing(SubclassFicationPayload).then((res) => {
                setassociatedSubclassification(res)
                loadAssociated();
            })

        })
    }

    const deleteTaging = (e: any) => {
        directoryServices.musicDirectoryCategoryDelete(e).then((res) => {

            directoryServices.musicDirectoryCategoryListing({ code: EditValue.barcodeNum, CategoryType: "Releases" }).then((res) => {
                setassociatedclassification(res)
                loadAssociated();
            })
        })
    }

    const handleNameOnChange = (n: any) => {
        classFicationPayload.pageNumber = n.pageNumber;
        classFicationPayload.pagesize = n.pageSize;
        ClassificationListing()
    }

    const handleNameOnChangeSub = (n: any) => {
        SubclassFicationPayload.pageNumber = n.pageNumber;
        SubclassFicationPayload.pagesize = n.pageSize;
        SubClassificationListing()
    }

    const onChangeContact = (e: any, error: any) => {

        if (e) {
            var payload = { artist: e.kontactCode, artistName: e.kontactName}
            EditValue= { ...EditValue, ...payload}
            setEditValue(EditValue);
            console.log(EditValue)
        }

        if (error === 'close') {
            setslider(false)
        }
    }

    const closeMasterRelease = (e: any) => {
        slider = false;
        setslider(slider)
    }

    const EditHandler = (e: any) => {
        var field_name = e.target.name;
        var field_value = e.target.value;

        console.log(field_name)
        if (field_name === "label") {
            //listImprint

            var value = (listImprint.filter((data: any) => (data.companyName === field_value))[0])
            console.log(value)
            setEditValue({ ...EditValue, ...{ [field_name]: value } });
        } else {
            setEditValue({ ...EditValue, ...{ [field_name]: field_value } });
        }

    }

    const handleFileChange = (e: any) => {

        var fileName = e.target.files[0];
        if (e.target.files) {
            setImageUpload(fileName)
            fileName = URL.createObjectURL(fileName)
            setEditValue({ ...EditValue, ...{ image: fileName } });
        }
    }

    const SaveAsset = () => {
        setSaveStatus(true)

        setEditValue({ ...EditValue });
        console.log(EditValue)
        directoryServices.ReleaseSave({ ...EditValue }, { validBarcode: false });
        directoryServices.uploadTrackImage(imageUpload, { "assetCode": EditValue.barcodeNum, "type": "Release" }).then((values: any) => {
            directoryServices.MainAssetsave({
                AssetCode: EditValue.barcodeNum, AssetContactCode: EditValue.artist, AssetContactName: EditValue.artistName,
                AssetImage: values.actual, AssetImageTH: values.thumbnail, AssetImprint: EditValue.label.companyName, AssetTitle: EditValue.title, AssetType: "R"
            })
                .then((values: any) => {
                    loadAssociated();
                })
        })
    }

    const loadAssociated = () => {
        directoryServices.musicDirectoryCategoryListing({ code: EditValue.barcodeNum, CategoryType: "Releases" }).then((res) => {
            setassociatedclassification(res)
        })

        SubclassFicationPayload.referenceCode = EditValue.barcodeNum;
        directoryServices.tagListing(SubclassFicationPayload).then((res) => {
            setassociatedSubclassification(res)
        })
    }
    const generateUPC = () => {
        console.log(EditValue)
        directoryServices.generateUPC({ masterCode: EditValue.masterRelease, codingStr: "DA" }).then((res) => {
            setEditValue({ ...EditValue, ...{ barcodeNum: res.barcodeNum } });
        })
    }

    const selectedMaster = (n: any) => {
        console.log(n)
        setEditValue({ ...EditValue, ...{ masterRelease: n.masterRelease, masterTitle: n.masterTitle } });

    }

    return (<>
        <Drawer open={param.open} onClose={closePage}  direction='right'            className='react-drawer-left allowVscroll allowHscroll'>

            <div className="ws-6 box pull-right box noBorderRadius noBorder full-height-vh">
                <div className='box-header bg-blue'>
                    <h1 className="pull-left ws-10"><i className="fa fa-sticky-note"></i> New Release</h1>
                </div>

                <div className='box-content'>
                    <div className="ws-12">

                        <div className="ws-11 form-format mb">
                            <label className="control-label">Master Release*</label>
                            <div className="label-entries ws-12">
                                <div className="ws-10">
                                    <input id="artist" type="text" name="masterRelease" value={EditValue.masterRelease} placeholder="Enter master Release Name" />
                                </div>

                                <div className="ws-1 m0">
                                    <button type="button" onClick={() => { setslider(true); setsliderIndex(2) }} className="icon-btn edit" ><i className="icon-user-add"></i></button>
                                </div>
                            </div>
                        </div>
 
                        <div className="ws-11 form-format mb">
                            <label className="control-label">Imprint*</label>
                            <div className="label-entries ws-12">
                                
                                <select key="label" name="label" className='w-93' value={(EditValue && EditValue.label && EditValue.label.companyName) ? EditValue.label.companyName : ""} onChange={EditHandler}>
                                    <option value="" > Choose an Imprint</option>

                                    {listImprint?.map(((values: any) => {
                                        return (
                                            <option value={values.companyName} label={values.companyName}>{values.companyName}</option>
                                        )
                                    }))}

                                </select>                                
                            </div>
                        </div>                        

                        <div className="ws-11 form-format mb">
                            <label className="control-label" >Code*</label>
                            <div className="label-entries ws-12">
                                <div className="ws-9">
                                    <input key="barcodeNum" type="text" className="ws-12" value={EditValue.barcodeNum} name="barcodeNum" onChange={EditHandler} placeholder="Enter UPC" />
                                </div>
                                <div className="m0">
                                    {<button type="button" disabled={!EditValue.masterRelease} className="icon-btn edit p9" onClick={generateUPC}>
                                        Generate UPC
                                    </button>}
                                </div>
                            </div>
                        </div>

                        <div className="ws-11 form-format mb">
                            <label className="control-label">Writer*</label>
                            <div className="label-entries ws-12">
                                <div className="ws-10">
                                    <input id="artist" type="text" name="artistName" value={EditValue.artistName} placeholder="Enter Writer Name" />
                                </div>

                                <div className="ws-2 ">                                    
                                    <ContactFormSearch onChange={onChangeContact} data={""}/>
                                    <button type="button" onClick={() => { setslider(true); setsliderIndex(1) }} className="icon-btn edit hide" ><i className="icon-user-add"></i></button>
                                </div>
                            </div>
                        </div>

                        <div className="ws-11 form-format mb">
                            <label className="control-label">Title*</label>
                            <div className="label-entries w-93">
                                <input key="title" type="text" name="title" value={EditValue.title} onChange={EditHandler} placeholder="Enter Title" />
                            </div>
                        </div>

                        <div className="ws-11 mtl">
                            <label className="control-label text-left ws-12 mt text-bold">Release Image</label>

                            <div className="ws-12 pm mb">
                                <div className="ws-4">

                                    {(EditValue.image) && <div className="box shadowCoverPicture shadow " >
                                        <div className="coverPicture">
                                            <img src={EditValue.image} className="ws-12"/>
                                            <img className="ws-12 hide" />
                                        </div>
                                    </div>}

                                    {!(EditValue.image) && <table className="coverPictureContainer">
                                        <tbody><tr>
                                            <td style={{ verticalAlign: "middle" }}>
                                                <i className="icon-new-registration"></i>
                                            </td>
                                        </tr>
                                        </tbody></table>}
                                </div>

                                <div className="ws-8 pm">
                                    <label className="icon-btn primary" style={{ marginTop: "15%" }}>Upload Image
                                        <input type="file" accept="image/*" id="file-upload" className="hide" onChange={handleFileChange} />
                                    </label>
                                    <span className="ws-12 mt">Maximum file size 2mb file types accepted .jpg/ .png/ .bmp (Resolution Minimum 300px X 230px).</span>
                                </div>
                            </div>

                        </div>

                    </div>

                    {(saveStatus) && <div className='ws-12'>
                        {<div className="form-format ws-12 mtl box pLarge" >
                            <label className="control-label text-left">Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={ClassificationSearch} placeholder="Type to search for classification" onChange={(e) => setClassificationSearch(e.target.value)} />
                                </div>
                                
                                <button className="icon-btn edit btn-xs pl pr pts" onClick={() => ClassificationListing()}>
                                    <i className="icon-search"></i>
                                </button>                                

                                {(ClassificationSearch.length > 1) && <div>
                                    <button className="icon-btn edit btn-xs pl pr pts" onClick={() => ClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                        {listClassification?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td width="20%"> <input type="checkbox" onClick={() => ClassificationSave(values.useFreeText)} /> </td>
                                                    <td>{values.useFreeText}</td>
                                                </tr>

                                            )
                                        })}

                                    </tbody>

                                </table>

                                {(() => {
                                    if (ClassificationtotalRow && ClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChange} totalRows={ClassificationtotalRow} />
                                    }
                                })()}

                            </div>

                            {(associatedclassification.length > 0) && <div className="form-format ws-12 mtl" ng-show="directoryClassifications.length > 0">
                                <label className="control-label text-left w-30 mt">Associated Classification(s):</label>
                                {associatedclassification?.map((values: any, index: any) => {

                                    return (
                                        <div className=''>
                                            <a className="btn ms ps" style={{ background: CommonUtilities.chartColors[index], color: "RGB(255,255,255)" }}>
                                                <span className="mts mb text-center" style={{ color: "#fff" }}>{values.categoryName}</span>
                                                <span className="pull-right mtss" onClick={() => deleteTaging(values.creatorCategoryId)}>
                                                    <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                </span>
                                            </a>
                                        </div>
                                    )
                                })}
                            </div>}

                            {(ClassificationtotalRow === 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No classification available  </div>
                            </div>}

                        </div>}

                        {<div className="form-format ws-12 mtl box pLarge">
                            <label className="control-label text-left">Sub Classification</label>
                            <div className="label-entries ws-12">
                                <div className="ws-8">
                                    <input type="text" value={SubClassificationSearch} placeholder="Type to search for Sub classification" onChange={(e) => setSubClassificationSearch(e.target.value)} />
                                </div>

                                <button className="icon-btn edit btn-xs pl pr pts" onClick={() => SubClassificationListing()}>
                                    <i className="icon-search"></i>
                                </button>
                                

                                {(SubClassificationSearch.length > 1) && <div>
                                    <button className="icon-btn edit btn-xs pl pr pts" onClick={() => SubClassificationSave(false)}>
                                        <i className="icon-save"></i>
                                    </button>
                                </div>}
                            </div>

                            <div className="ws-12">
                                <table className="table ml w-76">
                                    <tbody>
                                        {listSubClassification?.map((values: any) => {
                                            return (
                                                <tr>
                                                    <td width="20%"> <input type="checkbox" onClick={() => SubClassificationSave(values.code)} /> </td>
                                                    <td>{values.code}</td>
                                                </tr>
                                            )
                                        })}

                                    </tbody>

                                </table>

                                {(() => {
                                    if (SubClassificationtotalRow && SubClassificationtotalRow > 10) {
                                        return <Pagination onChange={handleNameOnChangeSub} totalRows={SubClassificationtotalRow} />
                                    }

                                })() }

                            </div>

                            {(associatedSubclassification.length > 0) && <div className="form-format ws-12 mtl">
                                <label className="control-label text-left w-30 mt ">Associated Sub Classification(s):</label>

                                { associatedSubclassification?.map((values: any, index: any) => {

                                    return (
                                        <div>
                                            <a className="btn ms ps" style={{ background: CommonUtilities.chartColors[index], color: "#fff" }}>
                                                <span className="mts mb text-center" style={{ color: "#fff" }}>{values.text}</span>
                                                <span className="pull-right mtss" onClick={() => deleteSubTaging(values.id)}>
                                                    <i className="icon-close1 text-s ms pls" style={{ color: "#fff" }}></i>
                                                </span>
                                            </a>
                                        </div>
                                    )
                                })}
                            </div>}

                            {(SubClassificationtotalRow === 0) && <div className="label-entries ws-8">
                                <div className="alert alert-info">No Subclassification available</div>
                            </div>}

                        </div>}
                    </div>}
                </div>

                <div className="box-footer">
                    <div className="pull-right">
                        <button className="icon-btn delete pull-right" onClick={closePage}> <i className="icon-close"></i> Close </button>
                        <button className="icon-btn edit pull-right" onClick={SaveAsset}> <i className="icon-save"></i> Save </button>
                    </div>
                </div>

            </div>
        </Drawer>

        {(() => {

            if (sliderIndex === 1) {
                return <SelectContact onChangeContact={onChangeContact} data={EditValue.artistName} hide={true} open={slider} />
            }

            if (sliderIndex === 2) {
                return <MasterReleaseForm selectedMaster={selectedMaster} closeMasterRelease={closeMasterRelease} data={EditValue.artistName} hide={true} open={slider} />
            }
        })()}

    </>)
}